document.addEventListener('DOMContentLoaded', function () {
    // Find ALL option drawer wrappers
    const drawers = document.querySelectorAll('.option-drawer-wrapper[data-options]');

    if (drawers.length === 0) return;

    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    // Activate images in a drawer the first time it is opened.
    // Images use data-src instead of src so they are not fetched on page load
    // (visibility:hidden + position:fixed means the browser treats them as
    // in-viewport, making loading="lazy" ineffective for these drawers).
    function loadDrawerImages(drawer) {
        drawer.querySelectorAll('img[data-src]').forEach(function (img) {
            if (!img.getAttribute('src')) {
                img.setAttribute('src', img.getAttribute('data-src'));
            }
        });
    }

    function openDrawer(targetDrawer) {
        loadDrawerImages(targetDrawer);

        const sidebar = targetDrawer.querySelector('.option-drawer');

        targetDrawer.classList.add('active');

        if (sidebar) {
            sidebar.style.transition = ''; 
            sidebar.style.transform = 'translateX(0)';
        }

        const scrollBarWidth = getScrollbarWidth();
        if (scrollBarWidth > 0) {
            document.body.style.paddingRight = scrollBarWidth + 'px';
        }

        document.body.classList.add('no-scrollY');
    }

    function closeDrawer(targetDrawer) {
        const sidebar = targetDrawer.querySelector('.option-drawer');

        if (sidebar) {
            sidebar.style.transform = 'translateX(100%)';

            const onTransitionEnd = function handler(e) {
                if (e.propertyName === 'transform') {
                    targetDrawer.classList.remove('active');
                    document.body.classList.remove('no-scrollY');
                    document.body.style.paddingRight = '';
                    sidebar.removeEventListener('transitionend', onTransitionEnd);
                }
            };

            sidebar.addEventListener('transitionend', onTransitionEnd);
        } else {
            targetDrawer.classList.remove('active');
            document.body.classList.remove('no-scrollY');
            document.body.style.paddingRight = '';
        }
    }

    // Existing option button logic
    document.querySelectorAll('[data-name$="-options"]').forEach(btn => {
        btn.addEventListener('click', function () {
            const optionType = this.getAttribute('data-name').replace('-options', '');
            const targetDrawer = document.querySelector(
                `.option-drawer-wrapper[data-options="${optionType}"]`
            );
            if (targetDrawer) {
                openDrawer(targetDrawer);
            }
        });
    });

    // New logic for 'option-row__clickable'
    document.querySelectorAll('.option-row__clickable').forEach(btn => {
        btn.addEventListener('click', function () {
            const nameAttr = this.getAttribute('data-name');
            if (nameAttr === 'size-collection-size') {
                const targetDrawer = document.querySelector(
                    '.option-drawer-wrapper[data-options="size-collection"]'
                );
                if (targetDrawer) {
                    openDrawer(targetDrawer);
                }
            }
        });
    });

    // Drawer close logic
    drawers.forEach(drawer => {
        const closeBtn = drawer.querySelector('.option-drawer__closer');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => closeDrawer(drawer));
        }

        drawer.addEventListener('click', function (e) {
            if (e.target === drawer) {
                closeDrawer(drawer);
            }
        });
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;

        const activeDrawer = document.querySelector('.option-drawer-wrapper.active');
        if (activeDrawer) {
            closeDrawer(activeDrawer);
        }
    });
});